var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "bg-grey-1" },
    [
      _c(
        "q-card-media",
        {
          class: _vm.liveClassBlocked ? "disable-image" : "",
          on: {
            click: function($event) {
              return _vm.goLiveClass()
            }
          }
        },
        [
          _vm.live_class.image_small
            ? _c("img", { attrs: { src: _vm.live_class.image_small } })
            : _vm._e(),
          !_vm.live_class.image_small
            ? _c("img", { attrs: { src: _vm.getPlaceholder } })
            : _vm._e()
        ]
      ),
      _c("q-card-main", { staticClass: "relative-position" }, [
        _c("div", { staticClass: "line-card bg-primary absolute-top" }),
        _c("div", { staticClass: "row q-my-sm" }, [
          _c(
            "div",
            {
              staticClass: "col-12",
              on: {
                click: function($event) {
                  return _vm.goToLiveClass()
                }
              }
            },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-12 q-title text-weight-medium",
                    class: _vm.liveClassBlocked ? "text-faded" : "text-primary"
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.live_class.title) +
                        "\n                    "
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-12 q-subheading text-weight-regular",
                    class: _vm.liveClassBlocked ? "text-faded" : "text-primary"
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("live_class_date")) +
                        " " +
                        _vm._s(_vm.fDate(_vm.live_class.date)) +
                        " " +
                        _vm._s("(" + _vm.live_class.timezone + ")") +
                        "\n                    "
                    )
                  ]
                )
              ])
            ]
          ),
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "row gutter-sm" }, [
              _c("div", { staticClass: "col-6" }, [
                _vm.live_class.areas.length > 0
                  ? _c("p", { staticClass: "caption" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("areas")) +
                          "\n                        "
                      )
                    ])
                  : _vm._e(),
                _vm.live_class.areas.length > 0
                  ? _c(
                      "p",
                      { staticClass: "tooltip q-mb-sm" },
                      _vm._l(_vm.live_class.areas, function(area, index) {
                        return _c("span", { key: index }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.getArea(area))
                          ),
                          _vm.live_class.areas.length - 1 > index
                            ? _c("span", [_vm._v(", ")])
                            : _vm._e()
                        ])
                      }),
                      0
                    )
                  : _vm._e()
              ]),
              _c("div", { staticClass: "col-6" }, [
                _vm.live_class.tags.length > 0
                  ? _c("p", { staticClass: "caption" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("tags")) +
                          "\n                        "
                      )
                    ])
                  : _vm._e(),
                _c(
                  "p",
                  { staticClass: "tooltip q-mb-sm" },
                  _vm._l(_vm.live_class.tags, function(tag, index) {
                    return _c("span", { key: index }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.getTag(tag))
                      ),
                      _vm.live_class.tags.length - 1 > index
                        ? _c("span", [_vm._v(", ")])
                        : _vm._e()
                    ])
                  }),
                  0
                )
              ])
            ])
          ])
        ])
      ]),
      _vm.showSubscribeButton ? _c("q-card-separator") : _vm._e(),
      _vm.showSubscribeButton
        ? _c(
            "q-card-actions",
            [
              _c("q-btn", {
                staticClass: "full-width",
                attrs: {
                  color: _vm.getSubscribeButtonColor,
                  label: _vm.$t(_vm.getSubscribeButtonLabel),
                  icon: _vm.getSubscribeButtonIcon,
                  disable: !_vm.has_vacancy
                },
                on: {
                  click: function($event) {
                    return _vm.subscribeLiveClass()
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }